/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { CardButtonsStatusEnum, ExpandableCard } from './models';
import { AlertController } from '@ionic/angular';
import { ViewConfigurationService } from 'src/domain/view-configuration';
import { PlatformProvider } from 'src/shared/services';
import { Device } from '@capacitor/device';
@Component({
	selector: 'app-expandable-card',
	templateUrl: './expandable-card.component.html',
	styleUrls: ['./expandable-card.component.scss']
})
export class ExpandableCardComponent implements OnChanges, OnInit {
	@Input() public cardData: ExpandableCard;
	@Input() public noApiStatus: boolean;
	@Input() public connection: any;
	@Input() public workfileName: any;
	@Input() public isReadonlyMode: boolean;
	@Input() public isParent: boolean;
	@Input() public isDeleteActionAllowed: boolean;
	@Input() public workfileId?: string;
	@Input() public configHeader: any;
	@Input() public buttonsStatus: CardButtonsStatusEnum;
	@Output() public selectedCard: EventEmitter<number> = new EventEmitter();
	@Output() public deleteRecordAction: EventEmitter<number> = new EventEmitter();
	@Output() public createDupAction: EventEmitter<number> = new EventEmitter();
	@Output() public newFromAction: EventEmitter<number> = new EventEmitter();

	public showItemOptions: boolean;
	public fusionId: any;
	public currentDeviceId: string;
	public connectionStorage: string = "CONNECTION_ID";
	public deviceInfo: string;
	public userLogged: any;
	public userDetails: any;

	// Validation variable
	public notValidObject: any;

	constructor(
		private alertController: AlertController,
		private viewConfigurationService: ViewConfigurationService,
		private platformProvider: PlatformProvider,
	) {}

	/* eslint-disable @typescript-eslint/no-unused-vars */
	public ngOnChanges(_: SimpleChanges): void {
		this.showItemOptions = !this.isReadonlyMode && this.isDeleteActionAllowed;
	}

	public async ngOnInit(): Promise<void> {
		console.log(this.cardData);
	}

	public toggleExpandCollapse(e: any): boolean {
		e.stopPropagation();
		return (this.cardData.isExpanded = !this.cardData.isExpanded);
	}

	public checkConnection(e: any): void {
		e.stopPropagation();
		this.presentAlert();
	}

	public checkValidation(e: any): void {
		e.stopPropagation();
		this.presentInvalidValidation();
	}

	public selectCard(): void {
		this.selectedCard.emit(this.cardData.id);
	}

	public deleteRecord(e: MouseEvent): void {
		e.stopPropagation();
		this.deleteRecordAction.emit(this.cardData.id);
	}

	public createDup(e: any): void {
		e.stopPropagation();
		this.createDupAction.emit(this.cardData.id);
	}

	public newFrom(e: any): void {
		e.stopPropagation();
		this.newFromAction.emit(this.cardData.id);
	}

	public async presentInvalidValidation() {
		// this.cardData.isValid = true;
	} 

	public async presentAlert() {
		const connectionID = await this.viewConfigurationService.getConnectionId();
		const matchedConnection = this.connection?.find(conn => conn.connectionId === connectionID);
	
		const ipAddress = matchedConnection?.serverPath
			.replace(/^https?:\/\//, '')
			.replace(/\/.*$/, '');
	
		const localInputData = await this.viewConfigurationService.getLocalInput(this.workfileId);
		const transferOutWorkfile = await this.viewConfigurationService.getTFWorkfile();
		this.currentDeviceId = await this.viewConfigurationService.getDeviceID();
		this.deviceInfo = this.getDeviceInfo();
	
		this.extractFusionId();
	
		const flattenedLocalInput = localInputData.flatMap(v => v.split("&"));
		const flattenedTransferOutWorkfile = transferOutWorkfile.flatMap(v => v.split("&"));
		
		const titleExists = flattenedLocalInput.includes(this.cardData.secondTitle);
		const workfileExist = flattenedTransferOutWorkfile.includes(this.workfileId);
	
		const message = await this.constructAlertMessage(titleExists, matchedConnection, ipAddress, workfileExist);
	
		const alert = await this.alertController.create({
			header: '',
			subHeader: '', 
			message: message,
			buttons: ['Close'],
		});
		await alert.present();
	}
	
	private getDeviceInfo(): string {
		switch (this.platformProvider.getPlatform()) {
			case 0:
				return "iPhone";
			case 1:
				return "Android";
			default:
				return "Web";
		}
	}
	
	private extractFusionId(): void {
		if (this.configHeader && this.configHeader.length > 0) {
			const fusionID = this.configHeader[0].fusionID;
			this.fusionId = fusionID.split(':');
		} else {
			console.error('Config header is not defined or empty');
		}
	}
	
	private async constructAlertMessage(titleExists: boolean, matchedConnection: any, ipAddress: string, workfileExist: boolean): Promise<string> {
		const deviceData = await Device.getInfo()
		const noApi = `<h4>No API Connection</h4>`

		const apiStatus = await this.viewConfigurationService.getApiStatus()
		
		if (apiStatus == '0') {
			if (workfileExist) {
				return `<strong>Database: </strong> ${this.fusionId[0]}
						<br><strong>Server:</strong> ${this.fusionId[1]}
						<br><strong>Business Unit:</strong> ${this.fusionId[2]}
						<br><strong>Date: </strong> ${this.fusionId[3]}`;
			}

			if(titleExists) {
				return `<strong>Created from:</strong> <code>${(deviceData.name == undefined) ? this.userLogged + " " + deviceData.operatingSystem : deviceData.name}</code>
					<br><br><strong>Server Alias:</strong> ${matchedConnection.serverAlias}
					<br><strong>IP Address:</strong> ${ipAddress}`;
			}
		} else {
			if (workfileExist) {
				return `${noApi}`;
			}

			if(titleExists) {
				return `${noApi}
					<strong>Created from:</strong> <code>${(deviceData.name == undefined) ? this.userLogged + " " + deviceData.operatingSystem : deviceData.name}</code>
					<br><br><strong>Server Alias:</strong> ${matchedConnection.serverAlias}
					<br><strong>IP Address:</strong> ${ipAddress}`;
			}
		}
	
		return "No Connection";
	}

}
